import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enUS } from 'date-fns/locale/en-US';

registerLocale('en-US', enUS);
setDefaultLocale('en-US');

// --- Geçici ağ hatalarını sustur (idle/sekme uykusu/anlık kopma) ---
// Arka planda dönen poll'ler "Failed to fetch" ile reddolunca, react-scripts'in
// dev hata overlay'i tüm ekranı kaplıyor. Bu hata sınıfı zararsız ve geçicidir;
// preventDefault ile overlay'i bastırırız. Gerçek kod hataları farklı tip/mesaj
// fırlattığı için onlar etkilenmez — sadece network-level "Failed to fetch" yutulur.
const isTransientNetworkError = (val) => {
  const msg = (val && (val.message || val.reason?.message || String(val.reason))) || '';
  return /Failed to fetch|NetworkError|Load failed|ERR_NETWORK|The network connection was lost/i.test(msg);
};
// capture:true → webpack-dev-server overlay'inin listener'ından ÖNCE çalışır;
// stopImmediatePropagation overlay'in bu event'i görmesini engeller.
window.addEventListener(
  'unhandledrejection',
  (e) => {
    if (isTransientNetworkError(e) || isTransientNetworkError(e.reason)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      // eslint-disable-next-line no-console
      console.warn('[net] geçici fetch hatası yok sayıldı:', e.reason?.message || e.reason);
    }
  },
  true
);
window.addEventListener(
  'error',
  (e) => {
    if (isTransientNetworkError(e) || isTransientNetworkError(e.error)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
